import {
  FETCH_KITCHEN_SURVEY_LIST_REQUEST,
  FETCH_KITCHEN_SURVEY_LIST_SUCCESS,
  FETCH_KITCHEN_SURVEY_LIST_FAILURE,
  FETCH_KITCHEN_SURVEY_DETAIL_REQUEST,
  FETCH_KITCHEN_SURVEY_DETAIL_SUCCESS,
  FETCH_KITCHEN_SURVEY_DETAIL_FAILURE,
  FETCH_KITCHEN_USER_SURVEY_LIST_REQUEST,
  FETCH_KITCHEN_USER_SURVEY_LIST_SUCCESS,
  FETCH_KITCHEN_USER_SURVEY_LIST_FAILURE,
} from "../actions/kitchenSurveyActions";

const initialState = {
  loading: false,
  kitchenSurveyList: [],
  kitchenUserSurveyList: [],
  kitchenSurveyDetail: null,
  error: null,
};

const kitchenSurveyReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_KITCHEN_SURVEY_LIST_REQUEST:
    case FETCH_KITCHEN_SURVEY_DETAIL_REQUEST:
    case FETCH_KITCHEN_USER_SURVEY_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_KITCHEN_SURVEY_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        kitchenSurveyList: action.payload,
      };

    case FETCH_KITCHEN_USER_SURVEY_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        kitchenUserSurveyList: action.payload,
      };

    case FETCH_KITCHEN_SURVEY_DETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        kitchenSurveyDetail: action.payload,
      };

    case FETCH_KITCHEN_SURVEY_LIST_FAILURE:
    case FETCH_KITCHEN_SURVEY_DETAIL_FAILURE:
    case FETCH_KITCHEN_USER_SURVEY_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default kitchenSurveyReducer;